import React from 'react';
import { PitchConfig, FlowDiagramLine } from '../../data/pitchData';

interface PitchSeedingProps {
  pitch: PitchConfig;
}

function FlowDiagramContent({ lines }: { lines: FlowDiagramLine[] }) {
  return (
    <>
      {lines.map((line, i) => {
        if (line.type === 'label') {
          return (
            <div
              key={i}
              className={`flow-diagram__section-label flow-diagram__section-label--${line.section || 'upper'}`}
            >
              {line.text}
            </div>
          );
        }
        if (line.type === 'note') {
          return (
            <span key={i} className="flow-diagram__note">
              {line.text + '\n'}
            </span>
          );
        }
        return <React.Fragment key={i}>{line.text + '\n'}</React.Fragment>;
      })}
    </>
  );
}

const PitchSeeding: React.FC<PitchSeedingProps> = ({ pitch }) => {
  return (
    <div className="pitch-seeding">
      <div className="seeding-description">
        <p>{pitch.seedingDescription}</p>
      </div>

      <div className="seeding-groups">
        {pitch.groups.map((group, gi) => (
          <div key={gi} className="seeding-group">
            <div className="seeding-group__title">{group.name}</div>
            <div className="seeding-group__seeds">
              {group.seeds.map((s, si) => (
                <div key={si} className="seed-row">
                  <span className={`seed-row__badge seed-row__badge--${s.color}`}>
                    {s.seed}
                  </span>
                  <span className={`seed-row__dest ${s.isBye ? 'seed-row__dest--bye' : ''}`}>
                    {s.dest}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flow-diagram">
        <div className="flow-diagram__title">Bracket Flow</div>
        <div className="flow-diagram__content">
          <FlowDiagramContent lines={pitch.flowDiagram} />
        </div>
      </div>
    </div>
  );
};

export default PitchSeeding;
